import React from 'react';
import get from 'lodash/get';
import classNames from 'classnames';
import ArrayHelper from 'foundation/array-helper';
import { favoritePlayerService } from 'general/js/services';
import { getRoundById } from 'general/js/helpers';
import { LazyImage } from 'project/lazy-image';
import { CountryFlag } from 'project/country-flag';
import { livePlayer, playerSitecoreData } from 'components/live-player';
import FavoritePlayerButton from 'components/favorite-player-button';
import { ScorePlayerCell } from 'components/scores';
import LeaderboardPlayerResult from './leaderboard-player-result';
import LeaderboardCellPlayerExtra from './leaderboard-cell-player-extra';

const LeaderboardCellPlayerLeaders = (
    {
        player,
        scoringCourseRound,
        currentRound,
        isPlayOff,
        liveScanner,
        ...rest
    }
) => {
    if (!player || ArrayHelper.isEmpty(player.rounds)) return null;

    const playerSD = player.sitecoreData || playerSitecoreData;
    const foundRound = getRoundById(player.rounds, currentRound);
    const playOffRoundId = liveScanner.liveComponents.leaderboard !== undefined ? liveScanner.liveComponents.leaderboard.playoffRoundId : 401;

    const renderIndicators = () => {
        return scoringCourseRound.holePars.map((holePar, i) => {
            const playerPar = get(foundRound, `info[${i}].playerPar`) || null;

            return (
                <ScorePlayerCell
                    childCss='leaderboard__cell-player-leaders-indicators-item'
                    key={holePar.holeId}
                    holePar={holePar.par}
                    playerPar={playerPar}
                />
            );
        });
    };

    const renderIndicatorsComponent = () => {
        if (!foundRound || ArrayHelper.isEmpty(foundRound.info)) return null;

        if (isPlayOff) {
            const playOffRound = getRoundById(player.rounds, playOffRoundId);

            return <LeaderboardPlayerResult playOffRound={playOffRound} />;
        }

        return (
            <div className="leaderboard__cell-player-leaders-indicators-wrapper">
                <div className="leaderboard__cell-player-leaders-current-round">
                    r{currentRound}
                </div>
                <div className="leaderboard__cell-player-leaders-indicators-list">
                    {renderIndicators()}
                </div>
            </div>
        );
    };


    const favouriteTheme = {};

    if (favoritePlayerService.isFavourite(player.id.toString())) {
        favouriteTheme.isWhite = true;
    } else {
        favouriteTheme.isDark = true;
    }

    const lastNameCss = classNames({
        'is-long': playerSD.lastName.length > 12
    });

    return (
        <div className="leaderboard__cell-player-leaders">
            <div className="leaderboard__cell-player-leaders-icon">
                <FavoritePlayerButton
                    trackCategory="Player"
                    trackAction="Favourites"
                    trackLabel={`${playerSD.firstName} ${playerSD.lastName}`}
                    playerId={player.id.toString()}
                    theme={favouriteTheme}
                />
            </div>

            <div className="leaderboard__cell-player-leaders-photo">
                <LazyImage image={playerSD.cutoutSrc} />
            </div>

            <div className="leaderboard__cell-player-leaders-content">
                <CountryFlag
                    childCss={'leaderboard__cell-player-leaders-flag'}
                    image={playerSD.countryFlagSrc}
                    title={playerSD.country}
                />

                <div className="leaderboard__player-extra">
                    <LeaderboardCellPlayerExtra {...rest} player={player} currentRound={currentRound} />
                </div>

                <button
                    className="leaderboard__cell-player-leaders-name-wrapper"
                    type="button"
                    onClick={() => livePlayer.show(player.id)}
                >
                    <div className="leaderboard__cell-player-leaders-first-name">
                        {playerSD.firstName}
                    </div>
                    <div className="leaderboard__cell-player-leaders-last-name-wrapper">
                        <div className={`leaderboard__cell-player-leaders-last-name ${lastNameCss}`}>
                            {playerSD.lastName}
                            {
                                playerSD.isAmateur &&
                                <span className="leaderboard__cell-player-leaders-amateur">(a)</span>
                            }
                        </div>
                        {
                            playerSD.sponsorLogoSrc &&
                            <div className="leaderboard__cell-player-logo">
                                <LazyImage image={playerSD.sponsorLogoSrc} />
                            </div>
                        }
                    </div>
                </button>

                {renderIndicatorsComponent()}
            </div>
        </div>
    );
};

export default LeaderboardCellPlayerLeaders;
